const TYPES = {
    trial: 'TRIAL',
    newMsisdn: 'NEW_MSISDN',
    link: 'LINK',
    voicemailRecording: 'VOICEMAIL_RECORDING'
};

class Notifications {
 	  [x: string]: any;
    static $inject = ['Users', 'NotificationsService'];
    constructor(Users, NotificationsService) {
        this.Users = Users;
        this.NotificationsService = NotificationsService;
        this.inDanger = false;
    }

    $onInit() {
        this.refresh();
    }

    setTrialStatus(inDanger, label) {
        this.inDanger = inDanger;
        this.trialLabel = label;
    }

    refresh() {
        this.NotificationsService.get({}, res => {
          this.notifications = res.notifications;
          this.isTrial = res.trial;
          this.trialExpirationDate = res.trialExpirationDate;
        });
    }

    checkType(notification, notificationType) {
        return notification.type === TYPES[notificationType];
    }

    hasLabel() {
        return this.trialLabel || this.notifications && this.notifications.length > 0;
    }

    getNotificationsLabel() {
        return this.trialLabel || this.notifications.length;
    }

}


export default {
    template : require('./notifications.html'),
    controller: Notifications
};
